import {
  INTRANET_SHORTCUT_ICONS,
  type IntranetLink,
  type IntranetWidget,
} from '@gb-ticket/shared-types';
import {
  BookOpenIcon,
  Building2Icon,
  CakeIcon,
  CalendarIcon,
  ClipboardListIcon,
  ClockIcon,
  ExternalLinkIcon,
  FileTextIcon,
  HardHatIcon,
  LinkIcon,
  NewspaperIcon,
  PhoneIcon,
  SearchIcon,
  UsersIcon,
  type LucideIcon,
} from 'lucide-react';

const ICONS: Record<(typeof INTRANET_SHORTCUT_ICONS)[number], LucideIcon> = {
  Newspaper: NewspaperIcon,
  BookOpen: BookOpenIcon,
  Search: SearchIcon,
  Users: UsersIcon,
  Phone: PhoneIcon,
  ExternalLink: ExternalLinkIcon,
  Calendar: CalendarIcon,
  Clock: ClockIcon,
  FileText: FileTextIcon,
  Link: LinkIcon,
  Building2: Building2Icon,
  Cake: CakeIcon,
  ClipboardList: ClipboardListIcon,
  HardHat: HardHatIcon,
};

export function ShortcutGlyph({
  name,
  className = 'size-5 shrink-0',
}: {
  name: string | null;
  className?: string;
}) {
  switch (name) {
    case 'Newspaper':
      return <NewspaperIcon className={className} aria-hidden />;
    case 'BookOpen':
      return <BookOpenIcon className={className} aria-hidden />;
    case 'Search':
      return <SearchIcon className={className} aria-hidden />;
    case 'Users':
      return <UsersIcon className={className} aria-hidden />;
    case 'Phone':
      return <PhoneIcon className={className} aria-hidden />;
    case 'Calendar':
      return <CalendarIcon className={className} aria-hidden />;
    case 'Clock':
      return <ClockIcon className={className} aria-hidden />;
    case 'FileText':
      return <FileTextIcon className={className} aria-hidden />;
    case 'Link':
      return <LinkIcon className={className} aria-hidden />;
    case 'Building2':
      return <Building2Icon className={className} aria-hidden />;
    case 'Cake':
      return <CakeIcon className={className} aria-hidden />;
    case 'ClipboardList':
      return <ClipboardListIcon className={className} aria-hidden />;
    case 'HardHat':
      return <HardHatIcon className={className} aria-hidden />;
    default:
      return <ExternalLinkIcon className={className} aria-hidden />;
  }
}

export function shortcutIcon(name: string | null): LucideIcon {
  if (name && (INTRANET_SHORTCUT_ICONS as readonly string[]).includes(name)) {
    return ICONS[name as (typeof INTRANET_SHORTCUT_ICONS)[number]];
  }
  return ExternalLinkIcon;
}

export function isInternalShortcut(url: string): boolean {
  return url.startsWith('/') && !url.startsWith('//');
}

/** Start page: switched-off rows stay in the editorial list, not in the grid or gadget stack. */
export function enabledIntranetLinks(links: readonly IntranetLink[]): IntranetLink[] {
  return links.filter((link) => link.enabled);
}

export function enabledIntranetWidgets(widgets: readonly IntranetWidget[]): IntranetWidget[] {
  return widgets.filter((widget) => widget.enabled);
}
